import { Component } from '@angular/core';

@Component({
    selector: 'lgv-current-year',
    template: `{{CurrentYear}}`,
})

export class CurrentYearComponent  {
    get CurrentYear(): string { return new Date().getFullYear().toString(); }
}
